import {useGlobalWindowToken} from '@/di/di.root-container.hooks';

import {useLayoutEffect, useState} from 'react';

import {HTMLElementId} from '@/constants';

export function useViewportSize(): {width: number; height: number} {
  const globalWindow = useGlobalWindowToken();

  const [size, setSize] = useState({
    width: globalWindow.document.body.clientWidth,
    height: globalWindow.document.body.clientHeight,
  });

  useLayoutEffect(() => {
    const calcSize = (): void => {
      const layout = globalWindow.document.getElementById(HTMLElementId.RootLayout);

      if (layout) {
        const {width, height} = layout.getBoundingClientRect();
        const bodyHeight = globalWindow.document.body.getBoundingClientRect().height;

        setSize({width, height: Math.min(height, bodyHeight)});
      }
    };

    const handleResize = (): void => {
      globalWindow.setTimeout(calcSize);
    };

    globalWindow.addEventListener('resize', handleResize);

    calcSize();

    return () => globalWindow.removeEventListener('resize', handleResize);
  }, []);

  return size;
}
